import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { useUsers } from '../metodos/userContext';
import CompletarPerfilNuevoTutor from './tutorRoute/Usuario/CompletarPerfil';
import PermisoInsuficiente from './Logins/noPermisos';
import HomeScreenTutor from './tutorRoute/HomeScreenTutor';
import HomeScreenAdmin from './adminRoute/HomeScreenAdmin';
import PresentarPrueba from './tutorRoute/Usuario/PresentarPrueba';

const HomeScreenPrincipal = () => {
  const { usuario ,loadingUsuario, errorUsuario} = useUsers();
  const location = useLocation();
  const [activeRoute, setActiveRoute] = useState('/solicitudes/disponibles');
  const navigate = useNavigate();

  // Actualizar la ruta activa cada vez que cambia la ubicación
  useEffect(() => {
      const path = location.pathname;
      
      // Manejar la ruta raíz
      if (path === '/') {
        setActiveRoute('/dashboard');
        navigate('/dashboard', { replace: true });
        return;
      }
      

  }, [location, navigate]);

  //cargando usuario
  if (loadingUsuario) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="inline-block h-16 w-16 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"></div>
          <p className="mt-4 text-lg font-medium text-gray-700">Cargando datos del usuario...</p>
        </div>
      </div>
    );
  }

  //usuario no cargado
  if(usuario === null){
    return (
      <div className="flex h-screen w-full items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="inline-block h-16 w-16 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"></div>
          <p className="mt-4 text-lg font-medium text-gray-700">Error notificar</p>
        </div>
      </div>
    );
  }

  //VERIFICAR ROL DEL USUARIO
  if(usuario.rol == "PROSPECTO"){
    //prospecto aprobado
    if(usuario.prospectoAprobado ){
        return (
          <PresentarPrueba/>
        );
    } 
    //prospecto no aprobado
    else{
      return (
          <CompletarPerfilNuevoTutor/>
        );
    }
   
  }

  //TUTOR
  if(usuario.rol =="TUTOR"){
     return (
        <div>
            <HomeScreenTutor/>
        </div>
    )
  }

  //verificar si tutor no esta expulsado, tambien sanciones, etc
  if(usuario.expulsado){
    return <PermisoInsuficiente />;
  }

  //ADMIN Y COLABORADOR
  if(usuario.rol == "ADMIN" || usuario.rol == "COLABORADOR"){
    return (
        <div>
            <HomeScreenAdmin/>
        </div>
    )
   }

  else {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-gray-100">
        <div className="text-center">
          <p className="text-lg font-medium text-red-600">Rol de usuario no reconocido</p>
          <p className="mt-2 text-gray-600">Contacta al administrador</p>
        </div>
      </div>
    );
  }

}

export default HomeScreenPrincipal
